module.exports = __webpack_public_path__ + "static/media/truck.73907e2b.svg";